import type { PortCallStatus } from '@felix/domain';
import { IconPointFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusTone } from '../../StatusBadge.js';

/** Ortağın renkleri: On Going yeşil, Planned mavi, Completed gri; iptal kırmızı. */
export const PORT_CALL_TONE: Record<PortCallStatus, StatusTone> = {
  planned: 'info',
  ongoing: 'success',
  completed: 'neutral',
  cancelled: 'danger',
};

export function PortCallStatusBadge({ status }: { status: PortCallStatus }) {
  const { t } = useTranslation();
  return (
    <StatusBadge tone={PORT_CALL_TONE[status]} icon={<IconPointFilled size={10} />}>
      {t(`portCalls.statuses.${status}`)}
    </StatusBadge>
  );
}
